module.exports = __webpack_public_path__ + "img/1.566102f4.png";